<script setup lang="ts">
import { ComboboxEmpty } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = defineProps<{
  asChild?: boolean
  as?: unknown
}>()
</script>

<template>
  <ComboboxEmpty v-bind="props" :class="cn('py-6 text-center text-sm', $attrs.class ?? '')">
    <slot />
  </ComboboxEmpty>
</template>
